module.exports = __webpack_public_path__ + "static/team-32-a24d4de09be384bfcedc11a659d27b19.jpg";